/**
 * @author      Dario Casertano <dario@casertano.name>
 * @copyright   Copyright (c) 2023 Casertano Dario – All rights reserved.
 * @license     Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International.
 */

import { settings } from "@/libraries/storage";
import Vue from 'vue'
import VueI18n, { LocaleMessages } from 'vue-i18n'

Vue.use(VueI18n)

const {
    VUE_APP_I18N_FALLBACK_LOCALE,
    VUE_APP_I18N_LOCALE,
} = process.env

function loadMessages(): LocaleMessages {
    const context = require.context("../assets/json/i18n", true, /[a-z]{2,3}\.json$/i);

    return context
        .keys()
        .map((key) => {
            const locales = key.match(/([a-z]{2,3})\.json$/i) || []

            return {
                key,
                locale: locales[ 0 ],
            }
        })
        .reduce(
            (messages, { key, locale }) => ({
                ...messages,
                [locale.replace('.json', '')]: context(key),
            }),
            {} as LocaleMessages
        )
}

const messages = loadMessages()

export const i18n = new VueI18n({
    fallbackLocale: VUE_APP_I18N_FALLBACK_LOCALE || Object.keys(messages)[0],
    locale: settings.get('system', 'pwa', 'language', VUE_APP_I18N_LOCALE || Object.keys(messages)[0]),
    messages,
    postTranslation: (str: string, key = "") => str || key,
})
